import React from 'react'

import { useConfigurationStore } from '@stores'
import { useFormatMoney } from '@hooks'
import { AtlasImageStyles } from '@utils/buildAtlasImageStyles'
import ImageTemplate from './ImageTemplate'
import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { useTranslation } from '@amusnet/translations/react'
import { cn } from '@amusnet/react-ui'

export type DeclineBonusInfo = {
    betValue: string
    bundleDetails: { styles: string; text: string }[]
}

export type DeclineBonusStyles = {
    primaryTextColor: string
    secondaryTextColor: string
    image?: string
    imageStyles?: AtlasImageStyles
    background: BuildGradientStyle
}

interface DeclineProps {
    bonusInfo?: DeclineBonusInfo
    styles: DeclineBonusStyles
}

const DeclineTemplate: React.FC<DeclineProps> = ({ bonusInfo, styles }) => {
    const { t } = useTranslation()
    const formatMoney = useFormatMoney()
    const currency = useConfigurationStore((state) => state.currency)

    if (bonusInfo) {
        const betValue = formatMoney(Number(bonusInfo.betValue))

        return (
            <div id="bonus-decline" className="flex flex-col items-center justify-between h-full">
                <div id="bonus-decline-content" className="flex flex-col w-full">
                    <ImageTemplate image={styles.image} imageStyles={styles.imageStyles} />

                    <div
                        id="bonus-decline-confirmation"
                        style={{ ...styles.background }}
                        className="flex flex-col items-center w-full mt-[-3px] pb-4"
                    >
                        <p
                            id="bonus-decline-text"
                            style={{ color: styles.primaryTextColor }}
                            className="text-4xl font-bold text-center px-[87px] leading-relaxed"
                        >
                            {t('gameui.bonusSystem.singleDeclineText')}
                        </p>

                        {bonusInfo.bundleDetails.map((details, index) => (
                            <p
                                id={`bonus-decline-detail-${index}`}
                                style={{ color: styles.secondaryTextColor }}
                                className={details.styles}
                            >
                                {details.text}
                            </p>
                        ))}

                        <p
                            id="bonus-decline-bet-amount"
                            style={{ color: styles.primaryTextColor }}
                            className="text-4xl font-black"
                        >
                            x {betValue} {currency}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div id="bonuses-decline" className="flex flex-col items-center justify-between">
            <div id="bonuses-decline-content" className="flex flex-col w-full">
                <ImageTemplate image={styles.image} imageStyles={styles.imageStyles} />

                <div
                    id="bonuses-decline-confirmation"
                    style={{ ...styles.background }}
                    className="flex flex-col items-center w-full h-[278px] mt-[-3px]"
                >
                    <p
                        id="bonuses-decline-text"
                        className={cn('text-4xl font-bold text-center pt-[84px] px-[87px]', styles.primaryTextColor)}
                    >
                        {t('gameui.bonusSystem.declineAllText')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default DeclineTemplate
